import type {
  ArticleSummary,
  DataSourceEntry,
  ProductListingFilter,
} from "@/types";

type ProductVariation = {
  [key: string]: DataSourceEntry[];
};

const useProductVariants = async () => {
  const allVariations = useState<ProductVariation | null>(
    "productVariations",
    () => null,
  );

  if (allVariations.value) {
    return allVariations;
  }

  const storyBlokApi = useStoryblokApi();

  const [
    { data: background },
    { data: price },
    { data: type },
    // { data: use },
    { data: design },
  ] = await Promise.all([
    storyBlokApi.get("cdn/datasource_entries", {
      datasource: "product-background",
    }),
    storyBlokApi.get("cdn/datasource_entries", { datasource: "product-price" }),
    storyBlokApi.get("cdn/datasource_entries", { datasource: "product-type" }),
    // storyBlokApi.get("cdn/datasource_entries", { datasource: "product-use" }),
    storyBlokApi.get("cdn/datasource_entries", {
      datasource: "surface-design",
    }),
  ]);

  allVariations.value = {
    type: (type?.datasource_entries || []).map((item: DataSourceEntry) => ({
      ...item,
      key: "type",
    })),
    // use: (use?.datasource_entries || []).map((item: DataSourceEntry) => ({
    //   ...item,
    //   key: "use",
    // })),
    price: (price?.datasource_entries || []).map((item: DataSourceEntry) => ({
      ...item,
      key: "price",
    })),
    design: (design?.datasource_entries || []).map((item: DataSourceEntry) => ({
      ...item,
      key: "designFeatures",
    })),
    background: (background?.datasource_entries || []).map(
      (item: DataSourceEntry) => ({ ...item, key: "backgroundColor" }),
    ),
  };

  return allVariations;
};

export const useProductFilter = async (preFilter: ProductListingFilter) => {
  const productVariations = await useProductVariants();

  const productFilters = [];

  if (!preFilter.productType) {
    productFilters.push({
      label: "Product type",
      filters: productVariations.value?.type || [],
    });
  }

  // if (!preFilter.use) {
  //   productFilters.push({
  //     label: "Use",
  //     filters: productVariations.value?.use || [],
  //   });
  // }

  if (!preFilter.price) {
    productFilters.push({
      label: "Price range",
      filters: productVariations.value?.price || [],
    });
  }

  let designFilters: DataSourceEntry[] = [];
  if (!preFilter.designFeature) {
    designFilters = [
      ...designFilters,
      ...(productVariations.value?.design || []),
    ];
  }
  if (!preFilter.backgroundColor) {
    designFilters = [
      ...designFilters,
      ...(productVariations.value?.background || []),
    ];
  }

  if (designFilters.length > 0) {
    productFilters.push({
      label: "Surface finish",
      filters: designFilters,
    });
  }

  return productFilters;
};

const useArticleCategoryAndTags = async () => {
  const articleCategoriesAndTags = useState<{
    [key: string]: DataSourceEntry[];
  } | null>("articleCategoriesAndTags", () => null);

  if (articleCategoriesAndTags.value) {
    return articleCategoriesAndTags.value;
  }

  const storyBlokApi = useStoryblokApi();
  const [{ data: categories }] = await Promise.all([
    storyBlokApi.get("cdn/datasource_entries", {
      datasource: "article-categories",
    }),
    // storyBlokApi.get("cdn/datasource_entries", {
    //   datasource: "article-tags",
    // }),
  ]);

  articleCategoriesAndTags.value = {
    categories: (categories?.datasource_entries || []).map(
      (item: DataSourceEntry) => ({
        ...item,
        key: "category",
      }),
    ),
    // tags: (tags?.datasource_entries || []).map((item: DataSourceEntry) => ({
    //   ...item,
    //   key: "tag",
    // })),
  };

  return articleCategoriesAndTags.value;
};

export const useArticleFilters = async (preFilter: ArticleSummary) => {
  const categoriesAndTags = await useArticleCategoryAndTags();

  const filters = [];

  if (!preFilter.category) {
    filters.push({
      label: "Category",
      filters: categoriesAndTags.categories || [],
    });
  }

  // if (!preFilter.tag) {
  //   filters.push({ label: "Tag", filters: categoriesAndTags.tags || [] });
  // }
  return filters;
};
